const API_CONFIG = {
  tekno: `http://${window.location.hostname}:5555/api`,
  "aws-tekno": "https://accounting.iotech.my.id/api",
  "aws-intercon": "https://accounting-intercon.iotech.my.id/api",
  default: "http://localhost:5555/api", // Fallback
};

/** PPIC web app of the same environment (deep links from Budget Monitoring, e.g. MPS dashboard shortage). */
const PPIC_UI = {
  tekno: "https://ppic.iotech.my.id",
  "aws-tekno": "https://ppic.iotech.my.id",
  "aws-intercon": "https://ppic-intercon.iotech.my.id",
  default: "https://ppic.iotech.my.id",
};

module.exports = API_CONFIG;
module.exports.PPIC_UI = PPIC_UI;
